var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { key: _vm._key, staticClass: "form-group" }, [
    _vm.title
      ? _c("label", { staticClass: "text-primary" }, [
          _vm._v(_vm._s(_vm.title)),
        ])
      : _vm._e(),
    _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col" }, [
        _vm.showSearch
          ? _c("div", { staticClass: "input-group d-flex flex-row" }, [
              _c(
                "div",
                {
                  staticClass: "relative",
                  staticStyle: { flex: "4", position: "relative" },
                },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "input-normal select-danger radius-0",
                      staticStyle: { flex: "9" },
                      attrs: {
                        "value-key": "id",
                        filterable: "",
                        remote: "",
                        placeholder: _vm.placeholder,
                        "remote-method": _vm.searchUsers,
                        loading: _vm.searching,
                        "no-data-text": "No results",
                      },
                      on: { change: _vm.onUserSelected },
                      model: {
                        value: _vm.selectedUser,
                        callback: function ($$v) {
                          _vm.selectedUser = $$v
                        },
                        expression: "selectedUser",
                      },
                    },
                    _vm._l(_vm.foundUsers, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: {
                          label: item.first_name + " " + item.last_name,
                          value: item,
                        },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              false
                ? _c("div", { staticClass: "input-group-append" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-success",
                        attrs: {
                          id: "inviteForm5",
                          type: "button",
                          "data-toggle": "collapse",
                          href: "#assignForm5",
                          role: "button",
                          "aria-expanded": "false",
                        },
                        on: {
                          click: function ($event) {
                            _vm.createUserExpaned = !_vm.createUserExpaned
                            _vm.selectedUser = null
                          },
                        },
                      },
                      [_c("i", { staticClass: "fas fa-user-plus" })]
                    ),
                  ])
                : _vm._e(),
            ])
          : _vm._e(),
        _vm.assignedUsers && !_vm.multi && _vm.showSelectedNames
          ? _c(
              "div",
              {
                staticClass: "hiddenToggle w-100",
                style: { marginTop: "10px" },
                attrs: { id: "assignList55" },
              },
              [
                _vm.assignedUsers.user && _vm.assignedUsers.user.first_name
                  ? _c(
                      "ul",
                      { staticClass: "list-group list-group-flush list my--3" },
                      [
                        _c("li", { staticClass: "list-group-item px-0" }, [
                          _c(
                            "div",
                            { staticClass: "row align-items-center mx-0" },
                            [
                              _c("div", { staticClass: "col-auto px-1" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "avatar avatar-sm rounded-circle",
                                    attrs: { href: "#" },
                                  },
                                  [
                                    _vm.assignedUsers.user &&
                                    _vm.assignedUsers.user.image
                                      ? _c("img", {
                                          attrs: {
                                            alt: "Image placeholder",
                                            src: _vm.assignedUsers.user.image,
                                          },
                                        })
                                      : _c("span", [
                                          _vm._v(
                                            "\n                    " +
                                              _vm._s(
                                                _vm.assignedUsers.user
                                                  .first_name &&
                                                  _vm.assignedUsers.user.first_name
                                                    .toUpperCase()
                                                    .substring(0, 1)
                                              ) +
                                              "\n                    " +
                                              _vm._s(
                                                _vm.assignedUsers.user
                                                  .last_name &&
                                                  _vm.assignedUsers.user.last_name
                                                    .toUpperCase()
                                                    .substring(0, 1)
                                              ) +
                                              "\n                  "
                                          ),
                                        ]),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "col ml-1 px-1 lh-1" }, [
                                _c("h6", { staticClass: "mb-0 lh-1" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "d-block",
                                      attrs: { href: "#!" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.assignedUsers.user.first_name &&
                                            _vm.assignedUsers.user.first_name
                                        ) +
                                          "\n                    " +
                                          _vm._s(
                                            _vm.assignedUsers.user.last_name &&
                                              _vm.assignedUsers.user.last_name
                                          )
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("small", { staticClass: "text-muted" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm.assignedUsers.user.email ==
                                        _vm.profile.email
                                        ? "You"
                                        : _vm.assignedUsers.user.email
                                    )
                                  ),
                                ]),
                              ]),
                              _vm.multi
                                ? _c("div", { staticClass: "col-auto px-1" }, [
                                    _c(
                                      "button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip.top-center",
                                            value: `Remove this user`,
                                            expression: "`Remove this user`",
                                            modifiers: { "top-center": true },
                                          },
                                        ],
                                        staticClass: "close",
                                        attrs: {
                                          type: "button",
                                          "aria-label": "Close",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onRemoveUserClicked(
                                              _vm.assignedUsers,
                                              0
                                            )
                                          },
                                        },
                                      },
                                      [_c("span", [_vm._v("×")])]
                                    ),
                                  ])
                                : _vm._e(),
                            ]
                          ),
                        ]),
                      ]
                    )
                  : _vm._e(),
              ]
            )
          : _vm._e(),
        (_vm.assignedUsers.length > 0 || _vm.defaults.length > 0) &&
        _vm.multi &&
        _vm.showSelectedNames
          ? _c(
              "div",
              {
                staticClass: "hiddenToggle w-100",
                attrs: { id: "assignList5" },
              },
              [
                _c(
                  "ul",
                  { staticClass: "list-group list-group-flush list my--3" },
                  [
                    _vm._l(_vm.defaults, function (au, ind) {
                      return _c(
                        "li",
                        { key: ind, staticClass: "list-group-item px-0" },
                        [
                          _c(
                            "div",
                            { staticClass: "row align-items-center mx-0" },
                            [
                              _c("div", { staticClass: "col-auto px-1" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "avatar avatar-sm rounded-circle",
                                    attrs: { href: "#" },
                                  },
                                  [
                                    au.user && au.user.image
                                      ? _c("img", {
                                          attrs: {
                                            alt: "Image placeholder",
                                            src: au.user.image,
                                          },
                                        })
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              au.user.first_name &&
                                                au.user.first_name
                                                  .toUpperCase()
                                                  .substring(0, 1)
                                            ) +
                                              "\n                    " +
                                              _vm._s(
                                                au.user.last_name &&
                                                  au.user.last_name
                                                    .toUpperCase()
                                                    .substring(0, 1)
                                              ) +
                                              "\n                  "
                                          ),
                                        ]),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "col ml-1 px-1" }, [
                                _c("h5", { staticClass: "mb-0" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "d-block",
                                      attrs: { href: "#!" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          au.user.first_name &&
                                            au.user.first_name
                                        ) +
                                          "\n                    " +
                                          _vm._s(
                                            au.user.last_name &&
                                              au.user.last_name
                                          ) +
                                          " (Default)"
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("small", [
                                  _vm._v(
                                    _vm._s(
                                      au.user.email == _vm.profile.email
                                        ? "You"
                                        : au.user.email
                                    )
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ]
                      )
                    }),
                    _vm._l(_vm.assignedUsers, function (au, ind) {
                      return _c(
                        "li",
                        { key: ind, staticClass: "list-group-item px-0" },
                        [
                          _c(
                            "div",
                            { staticClass: "row align-items-center mx-0" },
                            [
                              _c("div", { staticClass: "col-auto px-1" }, [
                                _c(
                                  "a",
                                  {
                                    staticClass:
                                      "avatar avatar-sm rounded-circle",
                                    attrs: { href: "#" },
                                  },
                                  [
                                    au.user && au.user.image
                                      ? _c("img", {
                                          attrs: {
                                            alt: "Image placeholder",
                                            src: au.user.image,
                                          },
                                        })
                                      : _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              au.user.first_name &&
                                                au.user.first_name
                                                  .toUpperCase()
                                                  .substring(0, 1)
                                            ) +
                                              "\n                    " +
                                              _vm._s(
                                                au.user.last_name &&
                                                  au.user.last_name
                                                    .toUpperCase()
                                                    .substring(0, 1)
                                              )
                                          ),
                                        ]),
                                  ]
                                ),
                              ]),
                              _c("div", { staticClass: "col ml-1 px-1" }, [
                                _c("h5", { staticClass: "mb-0" }, [
                                  _c(
                                    "a",
                                    {
                                      staticClass: "d-block",
                                      attrs: { href: "#!" },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          au.user.first_name &&
                                            au.user.first_name
                                        ) +
                                          "\n                    " +
                                          _vm._s(
                                            au.user.last_name &&
                                              au.user.last_name
                                          )
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("small", [
                                  _vm._v(
                                    _vm._s(
                                      au.user.email == _vm.profile.email
                                        ? "You"
                                        : au.user.email
                                    )
                                  ),
                                ]),
                              ]),
                              _c("div", { staticClass: "col-auto px-1" }, [
                                _c(
                                  "button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip.top-center",
                                        value: `Remove this user`,
                                        expression: "`Remove this user`",
                                        modifiers: { "top-center": true },
                                      },
                                    ],
                                    staticClass: "close",
                                    attrs: {
                                      type: "button",
                                      "aria-label": "Close",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.onRemoveUserClicked(au, ind)
                                      },
                                    },
                                  },
                                  [_c("span", [_vm._v("×")])]
                                ),
                              ]),
                            ]
                          ),
                        ]
                      )
                    }),
                  ],
                  2
                ),
              ]
            )
          : _vm._e(),
      ]),
      _c("div", { staticClass: "col" }, [
        _c(
          "div",
          {
            staticClass: "collapse multi-collapse",
            class: { show: _vm.createUserExpaned || true },
            attrs: { id: "assignForm5" },
          },
          [
            _c("div", { staticClass: "card card-body rounded-0 border-0" }, [
              _c("div", { staticClass: "form-group" }, [
                _vm._m(0),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.userInvite.full_name,
                      expression: "userInvite.full_name",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: { type: "text", placeholder: "Enter Full Name" },
                  domProps: { value: _vm.userInvite.full_name },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.userInvite, "full_name", $event.target.value)
                    },
                  },
                }),
              ]),
              _c("div", { staticClass: "form-group" }, [
                _vm._m(1),
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.userInvite.email,
                      expression: "userInvite.email",
                    },
                  ],
                  staticClass: "form-control",
                  attrs: {
                    type: "email",
                    name: "email",
                    placeholder: "Enter Email",
                  },
                  domProps: { value: _vm.userInvite.email },
                  on: {
                    input: function ($event) {
                      if ($event.target.composing) return
                      _vm.$set(_vm.userInvite, "email", $event.target.value)
                    },
                  },
                }),
              ]),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-sm-12 col-md-6" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-outline-primary btn btn-block",
                      attrs: { type: "button", "data-toggle": "collapse" },
                      on: { click: _vm.btnUserInviteClicked },
                    },
                    [_vm._v("\n                Invite\n              ")]
                  ),
                ]),
                false
                  ? _c("div", { staticClass: "col-sm-12 col-md-6" }, [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-outline-primary btn btn-block",
                          attrs: { type: "button", "data-toggle": "collapse" },
                          on: { click: _vm.btnUserCopyLinkClicked },
                        },
                        [_vm._v("\n                Copy Link\n              ")]
                      ),
                    ])
                  : _vm._e(),
              ]),
            ]),
          ]
        ),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "h6 font-weight-bold" }, [
      _c("small", { staticClass: "font-weight-bold" }, [_vm._v("Full Name")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("label", { staticClass: "h6 font-weight-bold" }, [
      _c("small", { staticClass: "font-weight-bold" }, [_vm._v("Email")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }